import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpPanelService } from '../../core/services/help-panel.service';

@Component({
  selector: 'sw-help-panel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './help-panel.component.html',
  styleUrl: './help-panel.component.scss'
})
export class HelpPanelComponent {
  readonly helpService = inject(HelpPanelService);

  readonly content = computed(() => this.helpService.getContent(this.helpService.currentPage()));

  readonly filteredArticles = computed(() => {
    const q = this.helpService.searchQuery().toLowerCase();
    const c = this.content();
    if (!c || !q) return c?.articles ?? [];
    return c.articles.filter(a => a.title.toLowerCase().includes(q) || a.body.toLowerCase().includes(q));
  });
}
